import React from "react";
interface ILabeledCheckboxProps {
    id: string;
    checked: boolean;
    onChange(checked: boolean): void;
    cssClass: string;
    labelCssClass: string;
    lableTitle: string;
}

const LabeledCheckbox = (props: ILabeledCheckboxProps) => {
    return (
        <>
            <input type="checkbox" name={props.id} id={props.id}
                checked={props.checked}
                onChange={(e) => props.onChange(e.target.checked)}
            />
            <label htmlFor={props.id} className={props.labelCssClass} >
                {/*<i className="checkbox"></i>*/}
                {props.lableTitle}
            </label>
        </>
    );
};
export default LabeledCheckbox;